import CategoryScoreGrid from './CategoryScoreGrid'
import DiscoveryScoreCard from './DiscoveryScoreCard'
import QuickWins from './QuickWins'
import RobotsPolicyMatrix from './RobotsPolicyMatrix'
import SeveritySummary from './SeveritySummary'
import SiteHealthCoverage from './SiteHealthCoverage'
import { CARD_CLASS } from './SiteHealthStyles'
import type { SiteHealthOverviewProps } from './siteHealthComponents.types'

export default function SiteHealthOverview({
  overview,
}: SiteHealthOverviewProps) {
  return (
    <div className="space-y-6">
      <div className="grid gap-6 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.5fr)]">
        <DiscoveryScoreCard overview={overview} />
        <SeveritySummary counts={overview.severityCounts} />
      </div>

      <SiteHealthCoverage overview={overview} />
      <CategoryScoreGrid overview={overview} />
      <QuickWins findings={overview.quickWins} />
      {overview.robotsPolicy && (
        <RobotsPolicyMatrix
          policy={overview.robotsPolicy}
          className={`${CARD_CLASS} p-6`}
        />
      )}
    </div>
  )
}
